/**
 * The locale sent to the backend as the `x-locale` header.
 *
 * Kept free of side effects so non-Apollo callers (e.g. the Stripe checkout
 * POST) can import it without pulling in the Apollo client.
 */
import i18n from './config';

// Lets LanguageSelector set the locale synchronously before refetching,
// immune to React effect timing / i18n.language races.
let _localeOverride: string | null = null;

/** Synchronously override the locale sent on all requests. Pass null to revert to i18n.language. */
export function setLocaleOverride(locale: string | null): void {
  _localeOverride = locale;
}

/** The locale to send as `x-locale`. */
export function getRequestLocale(): string {
  // resolvedLanguage is the normalized supported code ('cs'), while language can
  // still hold a raw browser value ('cs-CZ') right after first-visit detection.
  return _localeOverride ?? i18n.resolvedLanguage ?? i18n.language ?? 'en';
}
